import { render, staticRenderFns } from "./LojasCadastro.vue?vue&type=template&id=c1826b6c&"
import script from "./LojasCadastro.vue?vue&type=script&lang=ts&"
export * from "./LojasCadastro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports